// extracted by mini-css-extract-plugin
export default {"root":"EditListingCoachingAccreditationsPanel_root__bBvOz","form":"EditListingCoachingAccreditationsPanel_form__rQrjA","title":"EditListingCoachingAccreditationsPanel_title__3rdf9"};